import Flux from 'lib/flux';
import BookingRequestService from 'services/booking_request';
import BookingRequestConstants from 'constants/booking_request';
import debounce from 'throttle-debounce/debounce';

const gTagCompleteCheckout = (params) => {
  const {
    bookingId,
    currency,
    tourId,
    unitPrice,
    tourName,
    totalPrice,
    guests,
    total_without_service_fee,
    unit_price_for_initial_pricing,
    units_and_addons_detail,
    isGa4Enabled,
    discountPricing,
    totalTax,
  } = params;
  try {
    // eslint-disable-next-line no-undef
    googleTagManagerCompleteCheckout({
      booking_id: bookingId,
      total_price: totalPrice,
      currency: currency.toUpperCase(),
      tour_id: tourId,
      tour_name: tourName,
      unit_price: unitPrice,
      quantity: guests,
      discount_pricing: discountPricing,
      total_tax: totalTax,
      is_ga4_enabled: isGa4Enabled,
      total_without_service_fee,
      unit_price_for_initial_pricing,
      units_and_addons_detail,
    });
  } catch (error) {
    console.log('google tag error', error);
  }
};

const salesforceKruxCompleteCheckout = (params) => {
  const {
    date,
    guestEmail,
    tourName,
    guests,
    billingCity,
    billingRegion,
    npsAndBehaviorResponses,
    bookingDate,
    tourCity,
    guestGender,
  } = params;
  const { nps, purchase_behavior } = npsAndBehaviorResponses;

  try {
    // eslint-disable-next-line no-undef
    salesforceCompleteCheckout({
      date,
      guest_email: guestEmail,
      tour_name: tourName,
      guests,
      billing_city: billingCity,
      billing_region: billingRegion,
      nps,
      purchase_behavior,
      booking_date: bookingDate,
      tour_city: tourCity,
      guest_gender: guestGender,
    });
  } catch (error) {
    console.log('salesforce krux pixel error', error);
  }
};

const BookingRequestActionCreator = Flux.createActionCreator({
  change: debounce(400, function (fields) {
    this.dispatchAction(BookingRequestConstants.CHANGE, fields);
  }),

  save(params) {
    let onFullfilled;
    let onRejected;
    const _this = this;
    this.dispatchAction(BookingRequestConstants.SAVE);

    onFullfilled = function (resp) {
      _this.dispatchAction(BookingRequestConstants.SAVE_COMPLETED, resp);
    };

    onRejected = function (errors) {
      _this.dispatchAction(BookingRequestConstants.SAVE_FAILED, errors);
    };

    BookingRequestService.save(params).then(onFullfilled, onRejected);
  },

  commit(params) {
    let onFullfilled;
    let onRejected;
    const _this = this;
    this.dispatchAction(BookingRequestConstants.COMMIT);

    onFullfilled = function (resp) {
      if (!resp.actionRequired) {
        gTagCompleteCheckout(resp);
        salesforceKruxCompleteCheckout(resp);
      }
      _this.dispatchAction(BookingRequestConstants.COMMIT_COMPLETED, resp);
    };

    onRejected = function (errors) {
      _this.dispatchAction(BookingRequestConstants.COMMIT_FAILED, errors);
    };

    BookingRequestService.commit(params).then(onFullfilled, onRejected);
  },

  applyDiscount(params) {
    let onFullfilled;
    let onRejected;
    const _this = this;

    this.dispatchAction(BookingRequestConstants.APPLY_DISCOUNT);

    onFullfilled = function (resp) {
      _this.dispatchAction(
        BookingRequestConstants.APPLY_DISCOUNT_COMPLETED,
        resp
      );
    };

    onRejected = function (xhr, textStatus, error) {
      const resp = xhr.responseJSON;
      _this.dispatchAction(BookingRequestConstants.APPLY_DISCOUNT_FAILED, resp);
    };

    BookingRequestService.applyDiscount(params).then(onFullfilled, onRejected);
  },

  removeDiscount(params) {
    let onFullfilled;
    let onRejected;
    const _this = this;

    this.dispatchAction(BookingRequestConstants.REMOVE_DISCOUNT);

    onFullfilled = function (resp) {
      _this.dispatchAction(
        BookingRequestConstants.REMOVE_DISCOUNT_COMPLETED,
        resp
      );
    };

    onRejected = function (xhr, textStatus, error) {
      const resp = xhr.responseJSON;
      _this.dispatchAction(
        BookingRequestConstants.REMOVE_DISCOUNT_FAILED,
        resp
      );
    };

    BookingRequestService.removeDiscount(params).then(onFullfilled, onRejected);
  },

  fetchSummary(id) {
    let onFullfilled;
    let onRejected;
    let _this;

    _this = this;
    onFullfilled = function (resp) {
      _this.dispatchAction(
        BookingRequestConstants.FETCH_SUMMARY_COMPLETED,
        resp
      );
    };
    onRejected = function (xhr, textStatus, error) {
      _this.dispatchAction(BookingRequestConstants.FETCH_SUMMARY_FAILED);
    };
    this.dispatchAction(BookingRequestConstants.FETCH_SUMMARY);
    BookingRequestService.fetchSummary({ id }).then(onFullfilled, onRejected);
  },

  completeAuth(params) {
    BookingRequestService.updatePayment(params).then(() => {
      this.dispatchAction(BookingRequestConstants.AUTH_COMPLETED, {});
    });
  },

  setStripePaymentError(error) {
    this.dispatchAction(BookingRequestConstants.STRIPE_PAYMENT_ERROR, error);
  },

  addCardElement(card) {
    this.dispatchAction(BookingRequestConstants.ADD_STRIPE_CARD_ELEMENT, card);
  },

  resetStripeAuth() {
    this.dispatchAction(BookingRequestConstants.RESET_STRIPE_AUTH);
  },

  setStripeToken(token) {
    this.dispatchAction(BookingRequestConstants.SET_STRIPE_TOKEN, token);
  },
});

export default BookingRequestActionCreator;
